import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import templateServices from '../../services/TemplateServices';
import { autorun } from 'mobx';

@inject('LayoutTemplateStore')
@observer
class RightMenuComponent extends Component {
  constructor(props) {
		super(props)
    let dataComps = []
    let container = 'bodyContainer';
    let position = 'rightContainer';

    dataComps = templateServices.listDataCompsByContainerPosition(this.props.LayoutTemplateStore, container, position, "masterBodyLayout");
    this.state = {
      comps: templateServices.listComponentsByDataNoGrid(dataComps) || (<div></div>),
      isUseMasterLayout: true
    }   
  }

  componentDidMount() {
      this.autorun = autorun(() => {
          let isUseMasterLayout = this.props.LayoutTemplateStore.isUseMasterLayout;
          if (this.state.isUseMasterLayout !== isUseMasterLayout) {
              let container = 'bodyContainer';
              let position = 'rightContainer';
              //console.log("right autorun");
              let dataComps = []
              if (isUseMasterLayout) {
                dataComps = templateServices.listDataCompsByContainerPosition(this.props.LayoutTemplateStore, container, position, "masterBodyLayout");
              } else {
                dataComps = templateServices.listDataCompsByContainerPosition(this.props.LayoutTemplateStore, container, position);

              }

            // console.log("dataComps", dataComps)
              this.setState({
                  comps: templateServices.listComponentsByDataNoGrid(dataComps) || ( <div> </div>),
                    isUseMasterLayout: isUseMasterLayout
                  }); 
               //console.log("this.state.comps", this.state.comps)
            }

          });
      }
  
  componentWillUnmount() {
    this.autorun();
  }

  render() {
    return (
      <div id ="right-menu-container" className={'right-menu-container ' + (this.props.className)?this.props.className:''}>
            {this.state.comps}
     </div>
    );
  }

}

export default RightMenuComponent;


// WEBPACK FOOTER //
// ./src/app/components/RightMenuComponent/index.js